import { Link } from "react-router-dom";
import { ArrowRight, ArrowLeft, Activity } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Footer } from "@/components/Footer";
import womanJournalingImage from "@/assets/woman-journaling-tracking.jpg";

// Personality: Clinical-soft, calming — muted sage, generous whitespace, illustrated icons.
const TrackerLanding = () => {
  return (
    <div className="min-h-screen bg-[hsl(145,25%,97%)]">
      <div className="container mx-auto px-6 py-10">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors">
          <ArrowLeft className="h-4 w-4" /> Back home
        </Link>
      </div>

      <section className="container mx-auto px-6 pt-8 pb-24 grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <span className="text-xs uppercase tracking-[0.3em] text-primary">The Tracker</span>
          <h1 className="mt-6 text-5xl md:text-7xl leading-[1.05] text-foreground" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>
            A gentle record of how you're really feeling.
          </h1>
          <p className="mt-8 text-lg text-foreground/70 max-w-lg leading-relaxed">
            No streaks. No shame. Just a soft, considered way to notice the patterns your body is
            already trying to show you — ready for the day you want to talk them through with a
            clinician.
          </p>
          <Button asChild size="lg" className="mt-10 px-10 py-6 text-lg">
            <Link to="/tracker"><Activity className="mr-2 h-5 w-5" /> Open tracker <ArrowRight className="ml-2 h-5 w-5" /></Link>
          </Button>
        </div>
        <div className="relative">
          <div className="aspect-[4/5] overflow-hidden rounded-3xl shadow-elegant">
            <img src={womanJournalingImage} alt="Journaling" className="w-full h-full object-cover" />
          </div>
        </div>
      </section>

      <section className="container mx-auto px-6 pb-24">
        <div className="grid md:grid-cols-3 gap-8">
          {[
            { img: "/sleep-quality-icon.png", title: "Sleep quality", desc: "Track restfulness and the small disruptions that add up." },
            { img: "/hot-flashes-icon.png", title: "Hot flashes", desc: "Log episodes with severity and likely triggers." },
            { img: "/mood-icon.png", title: "Mood & energy", desc: "Notice how you feel — no judgement, no scoring." },
          ].map((h) => (
            <div key={h.title} className="bg-background/60 backdrop-blur-sm rounded-2xl p-8 border border-foreground/5">
              <img src={h.img} alt="" className="w-16 h-16 rounded-full object-cover mb-5" />
              <h3 className="text-2xl mb-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{h.title}</h3>
              <p className="text-foreground/70 leading-relaxed">{h.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="container mx-auto px-6 pb-24">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-sm uppercase tracking-[0.3em] text-primary mb-4">Doctor-ready</p>
          <h2 className="text-4xl md:text-5xl mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Everything you log becomes a report worth taking to your appointment.
          </h2>
          <p className="text-foreground/70 leading-relaxed text-lg">
            Patterns, timelines, and the questions you'd otherwise forget — organised so the
            conversation starts where it should.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
};
export default TrackerLanding;
